import millionaire from './project_millionaire.png'

const images = {
	millionaire,
}

export { images }
